import React from "react";
import { Bold } from "react-feather";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

function Term() {
	return (
		<section className="term-section main-term-section">
			<div className="container">
				<Tabs className="row tf-tab">
					{/* <div className="col-lg-4">
            <TabList className="menu-tab tab-term po-sticky">
              <Tab className="ct-tab">1. Terms </Tab>
              <Tab className="ct-tab">2. Limitations </Tab>
              <Tab className="ct-tab">3. Revisions and errata</Tab>
              <Tab className="ct-tab">4. Site terms of use modifications</Tab>
              <Tab className="ct-tab">5. Risks</Tab>
            </TabList>
          </div> */}
					<div className="col-lg-12 mt-2">
						<div className="content-tab">
							<TabPanel className="term-content animation-tab pl-0">
								<h3 style={{ fontWeight: "bold" }} >Terms and Conditions</h3>
								<h5 className="mt-4"><span style={{ fontWeight: "bold" }}>Effective Date : </span>  2nd January 2025</h5>
								<p className="para-custom-color mt-3">
									Welcome to JobkiKhoj.com ("the Platform"), operated by People Labs ("we," "us," or "our"). By accessing or using the Platform, you agree to comply with and be bound by the following Terms and Conditions ("Terms"). If you do not agree to these Terms, you must not use the Platform.
								</p>

								<hr />
								<h5 className="mt-5" style={{ fontWeight: "bold" }}>1. Definitions </h5>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										<span className="terms-condtions-Defpoints" style={{paddingRight:'5px'}}>"Recruiter" </span> refers to individuals or organizations posting job opportunities on the Platform
									</li>
									<li className="para-custom-color">
										<span className="terms-condtions-Defpoints" style={{paddingRight:'5px'}}>"Candidate" </span>  refers to individuals seeking job opportunities through the Platform.
									</li>
									<li className="para-custom-color">
										{" "}
										<span className="terms-condtions-Defpoints" style={{paddingRight:'5px'}}>"Institute"</span> refers to academic or professional training organizations using the Platform.
									</li>
									<li className="para-custom-color">
										{" "}
										<span className="terms-condtions-Defpoints" style={{paddingRight:'5px'}}>"Corporate"</span>  refers to companies or entities using the Platform for recruitment purposes.
									</li>
									<li className="para-custom-color">
										{" "}
										<span  className="terms-condtions-Defpoints" style={{paddingRight:'5px'}}> "Admin"</span>  refers to the authorized personnel managing the overall operations of the Platform.
									</li>
								</ul>

								<hr />

								<h5 className="mt-5" style={{ fontWeight: "bold" }}> 2. Eligibility </h5>
								<ul className="list-dot">
									<p className="para-custom-color">
										By using the Platform, you represent and warrant that:
									</p>
									<li className="para-custom-color">
										{" "}
										You are at least 18 years old.
									</li>
									<li className="para-custom-color">
										You have the authority to enter into legally binding agreements.
									</li>
									<li className="para-custom-color">
										{" "}
										Your use of the Platform complies with all applicable laws and regulations in India.
									</li>
								</ul>
								<hr />

								<h5 className="mt-5" style={{ fontWeight: "bold" }}>3. User Registration </h5>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										Users must create an account to access certain features of the Platform.
									</li>
									<li className="para-custom-color">
										During registration, all information provided must be accurate, complete, and up to date.
									</li>
									<li className="para-custom-color">
										{" "}
										Users are responsible for maintaining the confidentiality of their login credentials and must notify us immediately of any unauthorized use of their accounts.
									</li>
									<li className="para-custom-color">
										{" "}
										We reserve the right to suspend or terminate any account that violates these Terms.
									</li>
								</ul>
								<hr />

								{/* ...    Start 4. Platform Usage*/}
								<h5 className="mt-5" style={{ fontWeight: "bold" }}>4. Platform Usage </h5>
								{/* 1 */}
								<h6 className="mt-4 ms-4" style={{ fontWeight: "bold" }} >Recruiters:</h6>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										Must ensure that job postings are accurate, lawful, and adhere to non-discriminatory practices.
									</li>
									<li className="para-custom-color">
										Responsible for managing and responding to applications through the Platform.
									</li>
								</ul>

								{/* 2 */}
								<h6 className="mt-4 ms-4" style={{ fontWeight: "bold" }} >Candidates:</h6>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										Must provide accurate resumes and professional details.
									</li>
									<li className="para-custom-color">
										Agree to participate in proctored assessments if required for the job application process.
									</li>

								</ul>

								{/* 3 */}
								<h6 className="mt-4 ms-4" style={{ fontWeight: "bold" }} >Institutes:</h6>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										Can upload and manage student profiles and CVs in bulk.
									</li>
									<li className="para-custom-color">
										Must ensure that all data uploaded is accurate and relevant.
									</li>

								</ul>

								{/* 4 */}
								<h6 className="mt-4 ms-4" style={{ fontWeight: "bold" }} >Corporates:</h6>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										Responsible for providing feedback on candidates and managing hiring processes efficiently.
									</li>
								</ul>

								{/* 5 */}
								<h6 className="mt-4 ms-4" style={{ fontWeight: "bold" }} >Admin:</h6>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										Oversees the proper functioning of the Platform, including monitoring job postings, managing content, and ensuring compliance with these Terms.
									</li>
								</ul>
								{/* ...    End 4. Platform Usage*/}

								<hr />

								<h5 className="mt-5" style={{ fontWeight: "bold" }}>5. Prohibited Activities</h5>
								<ul className="list-dot">
									<h6 className="mt-4" style={{ fontWeight: "bold" }} >You agree not to :</h6>

									<li className="para-custom-color">
										{" "}
										Use the Platform for any unlawful or fraudulent purposes.
									</li>
									<li className="para-custom-color">
										Upload or share content that is defamatory, obscene, or violates the intellectual property rights of others.
									</li>
									<li className="para-custom-color">
										{" "}
										Exploit, reverse-engineer, or misuse the Platform's technology, data, or services.
									</li>
									<li className="para-custom-color">
										Interfere with or disrupt the Platform’s operations or the experience of other users.
									</li>
								</ul>
								<hr />


								<h5 className="mt-5" style={{ fontWeight: "bold" }}>6. Payment and Fees</h5>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										The Platform may offer subscription models, pay-per-use options, or other payment arrangements for Recruiters, Institutes, or Corporates.
									</li>
									<li className="para-custom-color">
										All payments must be made in INR via the specified payment methods.
									</li>
									<li className="para-custom-color">
										{" "}
										Refunds, if applicable, will be processed in accordance with our refund policy, as detailed on the Platform.
									</li>
								</ul>
								<hr />

								<h5 className="mt-5" style={{ fontWeight: "bold" }}>7. Intellectual Property Rights </h5>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										All trademarks, logos, content, and materials on the Platform are the property of People Labs.
									</li>
									<li className="para-custom-color">
										Users are prohibited from reproducing, distributing, or creating derivative works of the Platform’s content without prior written consent.
									</li>
									<li className="para-custom-color">
										{" "}
										Users retain ownership of the content they upload but grant People Labs a non-exclusive, royalty-free license to use, display, and distribute it within the scope of the Platform’s operations.
									</li>
								</ul>
								<hr />

								<h5 className="mt-5" style={{ fontWeight: "bold" }}>8. Privacy  Policy</h5>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										<span> Our <a href="/Privacy-Policy">Privacy  Policy</a> governs how we collect, store, and use your personal data. By using the Platform, you consent to the
											collection and processing of your information in accordance with the Privacy  Policy.</span>
									</li>
								</ul>
								<hr />

								<h5 className="mt-5" style={{ fontWeight: "bold" }}>9. Limitation of Liability</h5>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										People Labs shall not be liable for:
									</li>
									<ol>
										<li className="para-custom-color">
											Any inaccuracies in job postings or candidate profiles.
										</li>
										<li className="para-custom-color">
											Disputes or interactions between users of the Platform.
										</li>
										<li className="para-custom-color">
											Any loss of data, interruptions, or technical issues.
										</li>
									</ol>
									<li className="para-custom-color">
										{" "}
										Users agree to indemnify People Labs against claims or damages arising from their misuse of the Platform.
									</li>
								</ul>
								<hr />

								<h5 className="mt-5" style={{ fontWeight: "bold" }}>10. Termination</h5>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										We reserve the right to suspend or terminate any user account that:
									</li>
									<ol>
										<li className="para-custom-color">
											Violates these Terms.
										</li>
										<li className="para-custom-color">
											Compromises the security or functionality of the Platform.
										</li>
									</ol>
									<li className="para-custom-color">
										{" "}
										Users may request account deletion at any time; however, certain data may be retained as required by law.
									</li>
								</ul>
								<hr />

								<h5 className="mt-5" style={{ fontWeight: "bold" }}>11. Dispute Resolution</h5>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										Any disputes or claims arising out of or relating to these Terms will be resolved in the courts of Uttar Pradesh, India, under Indian law.
									</li>
								</ul>
								<hr />

								<h5 className="mt-5" style={{ fontWeight: "bold" }}>12. Modifications to Terms</h5>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										People Labs reserves the right to update these Terms at its sole discretion. Significant changes will be communicated via email or Platform notifications.
									</li>

									<li className="para-custom-color">
										{" "}
										Continued use of the Platform constitutes acceptance of the updated Terms.
									</li>
								</ul>
								<hr />

								<h5 className="mt-5" style={{ fontWeight: "bold" }}>13. Third-Party Services</h5>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										The Platform may integrate with third-party tools or services. People Labs is not responsible for the availability or accuracy of such services.
									</li>
								</ul>
								<hr />

								<h5 className="mt-5" style={{ fontWeight: "bold" }}>14. Contact Us</h5>
								<p className="para-custom-color">If you have questions or require assistance, please contact us at:  </p>
								<ul className="list-dot">
									<li className="para-custom-color">
										{" "}
										<span style={{ fontWeight: "bold" }}>Email: </span> contact.jobkikhoj@gmail.com
									</li>

									<li className="para-custom-color">
										{" "}
										<span style={{ fontWeight: "bold" }}>Phone: </span> +91- 9220335725
									</li>
								</ul>

							</TabPanel>
						</div>
					</div>
				</Tabs>
			</div>
		</section>
	);
}

export default Term;
